import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base';
export default (function (props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $tick = _ref.$tick,
      $update = _ref.$update;
  var page_name = 'report-accident';
  var pn = "div[data-name=\"".concat(page_name, "\"]");
  var rows = [];

  var changeMonth = function changeMonth(e) {
    var $target = $(e.target);
    $f7.dialog.create({
      title: 'Chọn tháng',
      verticalButtons: true,
      closeByBackdropClick: true,
      buttons: [{
        text: 'Tháng này',
        onClick: function onClick() {
          return list('current');
        }
      }, {
        text: 'Tháng trước',
        onClick: function onClick() {
          return list('prev');
        }
      }]
    }).open();
  };

  var list = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(month) {
      var params, rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                month: moment().format('YYYY-MM') + '%'
              };
              $(pn + ' .month-label').text('Tháng này');

              if (month === 'prev') {
                params = {
                  month: moment().subtract(1, 'months').format('YYYY-MM') + '%'
                };
                $(pn + ' .month-label').text('Tháng trước');
              }

              _context.next = 5;
              return Base.api('Chamcongmuon', 'findAll', {
                where: 'created_at LIKE :month',
                where_data: params
              });

            case 5:
              rs = _context.sent;
              rows = rs.rows.map(function (row) {
                row.creator = Base.initdata.emps.find(function (e) {
                  return e.id === row.id_creator;
                }) || {
                  name: ''
                };
                row.user = Base.initdata.emps.find(function (e) {
                  return e.id === row.id_user;
                }) || {
                  name: ''
                };
                row.branch = Base.initdata.branches_noshift.find(function (e) {
                  return e.id === row.id_branch;
                }) || {
                  name: ''
                };
                return row;
              });
              $update();

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function list(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var send = function send() {
    $f7.dialog.confirm('Xác nhận gửi?', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var data, rs;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              data = $f7.form.convertToData($(pn + ' .ccm-form'));

              if (!(data.image === '')) {
                _context2.next = 4;
                break;
              }

              $f7.dialog.alert('Cần có ảnh');
              return _context2.abrupt("return", false);

            case 4:
              _context2.next = 6;
              return Base.api('Chamcongmuon', 'save', data);

            case 6:
              rs = _context2.sent;
              $f7.dialog.alert('Đã gửi đi');
              $(pn + ' .image-wrapper').html('');
              $(pn + ' input[name="image"]').val('');
              list('current');

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
  };

  $tick(function () {
    list('current');
    $(pn + ' #anhbangchung').change( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var files, formdata, rs, image;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              files = $(this)[0].files;

              if (!(files.length === 0)) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return");

            case 3:
              formdata = new FormData();
              formdata.append('token', localStorage.getItem(Base.tokenKey));
              formdata.append('image', files[0]);
              _context3.next = 8;
              return $f7.request({
                url: Base.apiEndPoint + "mdl=chamcongmuon&action=upload",
                method: 'POST',
                processData: true,
                contentType: 'multipart/form-data',
                dataType: 'json',
                data: formdata
              });

            case 8:
              rs = _context3.sent;
              $(pn + ' input[name="image"]').val(rs.data.filename);
              image = rs.data.filename;
              $(this).val('');
              $(pn + ' .image-wrapper').html("<img src=\"".concat(Base.uploadCCMURL, "/").concat(image, "\" style=\"width:100%\" />"));

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    })));
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="${page_name}">
  <div class="page-content">
    <div class="list no-margin">
      <ul class="ccm-form">
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">Cơ sở</div>
            <div class="item-input-wrap input-dropdown-wrap">
              <select name="id_branch">
                ${Base.initdata.branches_noshift && Base.initdata.branches_noshift.map(row=>$h`
                  <option value="${row.id}">${row.name}</option>
                `)}
              </select>
            </div>
          </div>
          <div class="item-inner">
            <div class="item-title item-label">Người cầm chìa khoá</div>
            <div class="item-input-wrap input-dropdown-wrap">
              <select name="id_user">
                ${Base.initdata.emps && Base.initdata.emps.map(row=>$h`
                  <option value="${row.id}">${row.name}</option>
                `)}
              </select>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">Ảnh bằng chứng (Ảnh cần đầy đủ biển hiệu)</div>
            <div class="item-input-wrap">
              <input type="file" id="anhbangchung" />
              <input type="hidden" name="image" />
              <div class="image-wrapper"></div>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <button class="button" @click="${send}">Gửi</button>
          </div>
        </li>
      </ul>
    </div>

    <div class="block text-align-center">
      Chỉ báo cáo việc chấm công muộn trong trường hợp người cầm chìa khoá đến MUỘN HƠN 08:15
    </div>

    <div class="card data-table">
      <div class="card-header">
        <div>Báo cáo</div>
        <div>
          <a @click="${changeMonth}" class="month-label">Tháng này</a>
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th>Người gửi</th>
            <th>Cầm chìa</th>
            <th>Cơ sở</th>
          </tr>
        </thead>
        <tbody>
          ${rows.length > 0 && rows.map(row=>$h`
            <tr>
              <td>
                <div>${row.creator.name}</div>
                <div class="gray-smaller">${moment(row.created_at).format(Base.dateTimeFormat)}</div>
              </td>
              <td>${row.user.name}</td>
              <td class="text-align-center">
                <div><img src="${Base.uploadCCMURL}/${row.image}" style="height: 50px;" /></div>
                <div class="gray-smaller">${row.branch.name}</div>
              </td>
            </tr>
          `)}
        </tbody>
      </table>
    </div>

  </div>
</div>
`
    }
    ;
});